import React, { useEffect } from "react";
import FilterGrid from "./grid/FilterGrid";
import PreCandidateList from "./grid/PreCandidateList";
import HeaderPreCandidate from "./header/HeaderPreCandidate";
import PreCandidateProvider from "./context/Context";
import { useTranslation } from "react-i18next";

const PrecandidateIndex = (props) => {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t("AtVitae - Pre-candidates");
  }, [t]);

  return (
    <PreCandidateProvider id={props.match.params.id}>
      <HeaderPreCandidate />
      <FilterGrid />
      <PreCandidateList />
    </PreCandidateProvider>
  );
};

export default PrecandidateIndex;
